module.exports = __webpack_public_path__ + "static/media/崧子浦community.d5919371.jpg";